import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { _throw } from "rxjs/observable/throw";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { ApiObjectFacade } from "../api-object/api-object.facade";
import { UserApiFacade } from "./user.api-facade";
import { User } from "./user.model";
import { UserStoreFacade } from "./user.store-facade";
import { ISymfonyUserRegistrationForm } from "../../../core/interfaces/interfaces";
import { Membership } from "../membership/membership.model";
import { UUID } from "angular2-uuid";

export class UserFacade extends ApiObjectFacade<User, UserApiFacade, UserStoreFacade> {

    syncOne(id: string, options?: ApiRequestOptions): Observable<any> {
        if (this.appFacade.objects.isChangePending(id)) {
            return of(undefined);
        }

        return this.api.get(id, options)
            .catch(error => {
                if (error.status === 404) {
                    this.store.get(id)
                        .take(1)
                        .do(item => {
                            this.store.remove(item, {persistable: true, restful: false});
                        })
                        .subscribe(item => undefined);
                    return of(undefined);
                } else {
                    return _throw(error);
                }
            })
            .do(object => this.insertIfFresher(object));
    }

    invite(
        accountId: string,
        registrationFormValues: ISymfonyUserRegistrationForm,
        accessGroups: Array<string>,
        contactTypes: Array<string>,
        jobStatuses: Array<string>,
        jobTypes: Array<string>,
        lookupTypes: Array<string>,
        taskTypes: Array<string>,
        isAdmin: boolean
    ): Observable<void> {
        return this.api.register(registrationFormValues)
            .map(response => response.json())
            .map(jsonResponse => {
                return new User(jsonResponse);
            })
            .map(user =>
                new Membership({
                    id: UUID.UUID(),
                    user: user.id,
                    account: accountId,
                    accessGroups,
                    contactTypes,
                    jobStatuses,
                    jobTypes,
                    lookupTypes,
                    taskTypes,
                    admin: isAdmin
                }))
            .do(membership => this.appFacade.objects.membership.store.create(membership))
            .map(() => {
                return;
            });
    }

    updatePassword(user: User, password: string): Observable<Response> {
        return this.api.updatePassword(user, password)
            .do(() => {
                this.store.updatePassword(user, password);
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.facade.ts